/* assets/booklist-finder.js
   - Uses window.BooklistSchoolInfo (config)
   - Uses window.booklistQuantities (your qty DB)
   - Uses window.bookPacksBySchool (recommended) OR falls back to window.bookPacks

   St Bernardine’s:
   - Splits into ListA / ListB / Music using tags: ListA, ListB, Music
   - Shows extra info above each list
   - Has an Add-to-cart button under each list
*/
(function () {
  const cfg = window.BooklistSchoolInfo || {};
  const schoolsCfg = cfg.schools || {};
  const listMeta = cfg.lists || {};
  const qtyDb = window.booklistQuantities || {};

  const form = document.getElementById("booklist-form");
  if (!form) return;

  const btn = document.getElementById("show-booklist-btn");
  const resultsWrapper = document.getElementById("booklist-results");
  const grid = document.getElementById("products-grid");

  const addAllButton = document.getElementById("add-to-cart-all");
  const bottomActions = addAllButton ? addAllButton.closest(".booklist-actions--bottom") : null;

  const familyTools = document.getElementById("family-tools");
  const familyMsg = document.getElementById("family-msg");
  const addAnotherBtn = document.getElementById("add-another-child");

  const schoolSelect = document.getElementById("school_select");
  const yeargroupSelect = document.getElementById("yeargroup_select");
  const schoolYearSelect = document.getElementById("schoolyear_select");

  // Product sources:
  // Preferred: window.bookPacksBySchool = { brightonstateschool:[...], ... }
  // Fallback: window.bookPacks = [...]
  const packsBySchool = window.bookPacksBySchool || null;
  const packsFallback = window.bookPacks || [];

  // Keep ONE booklist id per child (important for StB where they may click ListA then ListB)
  let currentBooklistId = null;

  

  // ---------------- Extra Dialogue for St Bernardine’s School ----------------

  /* New Function 5:19pm 5 Jan 2026 */
  const STB_NOTICE_ID = "stb-school-notice";

  function removeStBNotice() {
    const el = document.getElementById(STB_NOTICE_ID);
    if (el) el.remove();
  }

  function upsertStBNotice(groups) {
    if (!resultsWrapper) return;

    let el = document.getElementById(STB_NOTICE_ID);
    if (!el) {
      el = document.createElement("div");
      el.id = STB_NOTICE_ID;
      el.className = "booklist-notice";
    }

    const hasListB = !!(groups && groups.ListB && groups.ListB.length);
    const hasMusic = !!(groups && groups.Music && groups.Music.length);

    el.innerHTML = `
      <div class="booklist-notice__title">Important Information for St Bernardine’s School Customers</div>
      <ul>
        <li><strong>Minimum Order:</strong> $55</li>
        <li><strong>List A</strong> items are required as advised by the school.</li>
        ${hasListB ? `<li><strong>List B</strong> items are optional — only purchase if required.</li>` : ""}
        ${hasMusic ? `<li><strong>Music</strong> items are optional — add if applicable for your Year Group below.</li>` : ""}
      </ul>
    `;

    // Insert before the "Your Child's Recommended Booklist" heading
    const h2 = resultsWrapper.querySelector("h2");
    if (h2) resultsWrapper.insertBefore(el, h2);
    else resultsWrapper.insertBefore(el, resultsWrapper.firstChild);
  }
  /* New Function end here 5:19pm 5 Jan 2026 */

  // ---------------- Extra Dialogue for Brighton School ----------------
  /* New Function here 7pm 5 Jan 2026 */
  const BRIGHTON_NOTICE_ID = "brighton-school-notice";

  function removeBrightonNotice() {
    const el = document.getElementById(BRIGHTON_NOTICE_ID);
    if (el) el.remove();
  }

  function upsertBrightonNotice() {
    if (!resultsWrapper) return;

    let el = document.getElementById(BRIGHTON_NOTICE_ID);
    if (!el) {
      el = document.createElement("div");
      el.id = BRIGHTON_NOTICE_ID;
      el.className = "booklist-notice";
    }

    el.innerHTML = `
      <div class="booklist-notice__title">Important Information For Brighton State School Customers</div>
      <ul>
        <li><strong>Please disregard</strong> the pickup location at Regents Park News during checkout.</li>
        <li><strong>Pickup only:</strong> Church Car Park, 44 North Road, Brighton.</li>
        <li><strong>Date &amp; time</strong> will be communicated via <strong>Email</strong> or <strong>SMS</strong>.</li>
        <li><strong>Delivery:</strong> Your Bookpacks package can be dropped to your home as well.</li>
      </ul>
    `;

    // Insert above the "Your Child's Recommended Booklist" heading (the h2 inside #booklist-results)
    const h2 = resultsWrapper.querySelector("h2");
    if (h2) resultsWrapper.insertBefore(el, h2);
    else resultsWrapper.insertBefore(el, resultsWrapper.firstChild);
  }

  /* New Function end here 7pm 5 Jan 2026 */

  // ---------------- Extra Dialogue For Yugumbir State School ----------------
  const YUG_NOTICE_ID = "yug-school-notice";

  function removeYugNotice() {
    const el = document.getElementById(YUG_NOTICE_ID);
    if (el) el.remove();
  }

  function upsertYugNotice() {
    if (!resultsWrapper) return;

    let el = document.getElementById(YUG_NOTICE_ID);
    if (!el) {
      el = document.createElement("div");
      el.id = YUG_NOTICE_ID;
      el.className = "booklist-notice";
    }

    el.innerHTML = `
      <div class="booklist-notice__title">Important Information For Yugumbir State School Customers</div>
      <ul>
        <li><strong>Pickup Location : Regents Park News & Casket</strong></li>
        <li><strong>Shop Address</strong> : 2/3374 Mount Lindesay Hwy, Regents Park QLD 4118 </li>
        <li><strong>Order Collection : Please collect your order within 3 Business Days once it’s ready to pickup</strong></li>
        <li><strong>Order Status</strong> will be communicated via <strong>Email</strong> or <strong>SMS</strong>.</li>
        <li><strong>Date &amp; time</strong> will be communicated via <strong>Email</strong> or <strong>SMS</strong>.</li>
        <li><strong>Delivery:</strong> Your Bookpacks package can be dropped to your home as well for extra charges.</li>
      </ul>
    `;

    // Insert in the SAME place as Brighton/StB notices (top of results area)
    resultsWrapper.insertBefore(el, resultsWrapper.firstChild);
  }


  // ---------------- Helpers ----------------
  function normalizeTag(t) {
    return String(t || "")
      .toLowerCase()
      .trim()
      .replace(/\s+/g, "");
  }

  function getNormalizedTags(rawTags) {
    if (!rawTags) return [];
    const tags = Array.isArray(rawTags) ? rawTags : String(rawTags).split(",");
    return tags.map(normalizeTag);
  }

  function safeJsonParse(str, fallback) {
    try {
      return JSON.parse(str);
    } catch (e) {
      return fallback;
    }
  }

  function makeBooklistId() {
    return "BL-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 8);
  }

  async function fetchCart() {
    const r = await fetch("/cart.js", { credentials: "same-origin" });
    return r.json();
  }

  async function upsertBooklistMeta(entry) {
    const FAMILY_ATTR_KEY = "Booklists"; // cart.attributes["Booklists"] = JSON array

    const cart = await fetchCart();
    const existingRaw =
      cart && cart.attributes && cart.attributes[FAMILY_ATTR_KEY] ? cart.attributes[FAMILY_ATTR_KEY] : "[]";
    const list = safeJsonParse(existingRaw, []);

    const exists = list.some((x) => x && x.id === entry.id);
    const newList = exists ? list : list.concat([entry]);

    // Keep your old single-value attributes too (latest child)
    const compat = {
      "Parent first name": entry.parentFirst || "",
      "Parent last name": entry.parentLast || "",
      "Child first name": entry.childFirst || "",
      "Child last name": entry.childLast || "",
      "Booklist school": entry.schoolLabel || "",
      "Booklist year group": entry.yearGroupLabel || "",
      "Booklist school year": entry.schoolYearLabel || ""
    };

    const attributes = Object.assign({}, compat, {
      [FAMILY_ATTR_KEY]: JSON.stringify(newList)
    });

    return fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ attributes })
    });
  }

  function showFamilyTools(message) {
    if (!familyTools || !familyMsg) return;
    familyMsg.textContent = message;
    familyTools.style.display = "block";
    familyTools.scrollIntoView({ behavior: "smooth", block: "nearest" });
  }

  // New Button Implementation for St. Bernandine State School Start of 5 Jan 11pm Changes

  // ---------------- StB Optional Lists Prompt (after List A) ----------------
  const STB_OPTIONAL_PROMPT_ID = "stb-optional-lists-prompt";
  let stbOptionalCtx = null;

  // ---------------- Yugumbir Optional Lists Prompt ----------------
  const YUG_OPTIONAL_PROMPT_ID = "yug-optional-lists-prompt";
  let yugOptionalCtx = null;

  function hideYugOptionalPrompt() {
    const el = document.getElementById(YUG_OPTIONAL_PROMPT_ID);
    if (el) el.style.display = "none";
    yugOptionalCtx = null;
  }

  function ensureYugOptionalPromptEl() {
    let el = document.getElementById(YUG_OPTIONAL_PROMPT_ID);
    if (el) return el;

    el = document.createElement("div");
    el.id = YUG_OPTIONAL_PROMPT_ID;
    el.className = "booklist-family-tools"; // reuse existing styling
    el.style.display = "none";

    el.innerHTML = `
      <div class="booklist-family-tools__msg" id="yug-optional-msg"></div>
      <div class="booklist-family-tools__buttons">
        <button type="button" class="booklist-btn" data-yug-add="Required" style="display:none;"></button>
        <button type="button" class="booklist-btn" data-yug-add="Optional" style="display:none;"></button>
        <button type="button" class="booklist-btn booklist-btn--secondary" data-yug-continue="1">Continue</button>
      </div>
    `;

    // Handle clicks
    el.addEventListener("click", async (e) => {
      const addBtn = e.target.closest("[data-yug-add]");
      const contBtn = e.target.closest("[data-yug-continue]");

      if (contBtn) {
        // Continue -> show your normal "Add another child / Go to cart" bar
        
        if (yugOptionalCtx?.snap) {
          const s = yugOptionalCtx.snap;
          showFamilyTools(`✅ Added items for ${s.childFirst} ${s.childLast}. Want to add another child?`);
          hideYugOptionalPrompt();
        }
        return;
      }

      if (!addBtn || !yugOptionalCtx) return;

      const key = addBtn.getAttribute("data-yug-add"); // "Required" | "Optional"
      const section = yugOptionalCtx.grid?.querySelector(`[data-yug-section="${key}"]`);
      if (!section) return;

      const rows = Array.from(section.querySelectorAll(".booklist-row"));
      if (!rows.length) return;

      addBtn.disabled = true;
      addBtn.classList.add("booklist-btn--disabled");

      try {
        await addRowsToCart(rows, key, { suppressFamilyTools: true });
        yugOptionalCtx.added[key] = true;

        // Refresh prompt to only show what's missing
        showYugOptionalPrompt({
          grid: yugOptionalCtx.grid,
          snap: yugOptionalCtx.snap,
          exists: yugOptionalCtx.exists,
          added: yugOptionalCtx.added
        });
      } catch (err) {
        console.error(err);
        alert("Something went wrong while adding items. Please try again.");
      } finally {
        addBtn.disabled = false;
        addBtn.classList.remove("booklist-btn--disabled");
      }
    });

    if (familyTools && familyTools.parentNode) {
      familyTools.parentNode.insertBefore(el, familyTools);
    } else if (resultsWrapper) {
      resultsWrapper.appendChild(el);
    } else {
      document.body.appendChild(el);
    }
    return el;
  }

  function showYugOptionalPrompt({ grid, snap, exists, added }) {
    const el = ensureYugOptionalPromptEl();
    const msgEl = el.querySelector("#yug-optional-msg");

    const btnReq = el.querySelector('[data-yug-add="Required"]');
    const btnOpt = el.querySelector('[data-yug-add="Optional"]');

    const missingReq = exists.Required && !added.Required;
    const missingOpt = exists.Optional && !added.Optional;

    // If nothing missing -> fall back to normal family tools
    if (!missingReq && !missingOpt) {
      showFamilyTools(`✅ Added items for ${snap.childFirst} ${snap.childLast}. Want to add another child?`);
      hideYugOptionalPrompt();
      return;
    }

    // Message
    if (missingReq && missingOpt) {
      msgEl.textContent = "Required items List is Mandatory. Optional items may carry over from the previous year.";
    } else if (missingReq) {
      msgEl.textContent = "Required items List is Mandatory. Please add the Required Items list.";
    } else {
      msgEl.textContent = "Optional items may carry over from the previous year. Purchase only if replacement is needed.";
    }

    // Buttons: show only missing
    if (missingReq) {
      btnReq.style.display = "";
      btnReq.textContent = "Add Required Items list to cart (Mandatory)";
    } else {
      btnReq.style.display = "none";
    }

    if (missingOpt) {
      btnOpt.style.display = "";
      btnOpt.textContent = "Add Optional Items list to cart";
    } else {
      btnOpt.style.display = "none";
    }

    // Hide the normal family tools bar while this prompt is visible
    if (familyTools) familyTools.style.display = "none";

    yugOptionalCtx = { grid, snap, exists, added };

    el.style.display = "block";
    el.scrollIntoView({ behavior: "smooth", block: "nearest" });
  }
  // Ends here for Yugumbir New Changes 

  function hideStBOptionalPrompt() {
    const el = document.getElementById(STB_OPTIONAL_PROMPT_ID);
    if (el) el.style.display = "none";
    stbOptionalCtx = null;
  }

  function ensureStBOptionalPromptEl() {
    let el = document.getElementById(STB_OPTIONAL_PROMPT_ID);
    if (el) return el;

    el = document.createElement("div");
    el.id = STB_OPTIONAL_PROMPT_ID;
    el.className = "booklist-family-tools"; // reuse same styling as your existing box
    el.style.display = "none";

    el.innerHTML = `
      <div class="booklist-family-tools__msg" id="stb-optional-msg"></div>
      <div class="booklist-family-tools__buttons">
        <button type="button" class="booklist-btn" data-stb-add="ListA" style="display:none;"></button>
        <button type="button" class="booklist-btn" data-stb-add="ListB"></button>
        <button type="button" class="booklist-btn" data-stb-add="Music" style="display:none;"></button>
        <button type="button" class="booklist-btn booklist-btn--secondary" data-stb-continue="1">Continue</button>
      </div>
    `;

    // Insert it just before the existing familyTools box (if it exists), otherwise under results
    if (familyTools && familyTools.parentNode) {
      familyTools.parentNode.insertBefore(el, familyTools);
    } else if (resultsWrapper) {
      resultsWrapper.appendChild(el);
    }

    // Event delegation for prompt buttons
    el.addEventListener("click", async (ev) => {
      const addBtn = ev.target.closest("[data-stb-add]");
      const contBtn = ev.target.closest("[data-stb-continue]");

      if (!stbOptionalCtx) return;

      if (addBtn) {
        const key = addBtn.getAttribute("data-stb-add"); // "ListB" or "Music"
        const section = stbOptionalCtx.grid.querySelector(`[data-list-section="${key}"]`);
        if (!section) return;

        const rows = Array.from(section.querySelectorAll(".booklist-row"));
        if (!rows.length) return;

        addBtn.disabled = true;
        addBtn.classList.add("booklist-btn--disabled");
        const original = addBtn.textContent;
        addBtn.textContent = "Adding… please wait";

        try {
          await addRowsToCart(rows, key, { suppressFamilyTools: true });
          stbOptionalCtx.added[key] = true;

          // Refresh prompt so it only shows what's still missing
          showStBOptionalPrompt({
            grid: stbOptionalCtx.grid,
            snap: stbOptionalCtx.snap,
            exists: stbOptionalCtx.exists,
            added: stbOptionalCtx.added,
          });
          addBtn.textContent = `✅ ${original}`;
          // Keep disabled so they can’t accidentally add twice
        } catch (err) {
          console.error(err);
          alert("Something went wrong while adding items. Please try again.");
          addBtn.disabled = false;
          addBtn.classList.remove("booklist-btn--disabled");
          addBtn.textContent = original;
        }
        return;
      }

      if (contBtn) {
        // Hide optional prompt, then show your existing "Added items..." box
        const msg = `✅ Added items for ${stbOptionalCtx.snap.childFirst} ${stbOptionalCtx.snap.childLast}. Want to add another child?`;
        hideStBOptionalPrompt();
        hideYugOptionalPrompt();
        showFamilyTools(msg);
        return;
      }
    });

    return el;
  }

  function showStBOptionalPrompt({ grid, snap, exists, added }) {
    const el = ensureStBOptionalPromptEl();
    const msgEl = el.querySelector("#stb-optional-msg");

    const btnA = el.querySelector('[data-stb-add="ListA"]');
    const btnB = el.querySelector('[data-stb-add="ListB"]');
    const btnM = el.querySelector('[data-stb-add="Music"]');

    const titleA = (listMeta.ListA && listMeta.ListA.title) ? listMeta.ListA.title : "List A";
    const titleB = (listMeta.ListB && listMeta.ListB.title) ? listMeta.ListB.title : "List B";
    const titleM = (listMeta.Music && listMeta.Music.title) ? listMeta.Music.title : "Music";

    // figure out what's missing
    const missingA = exists.ListA && !added.ListA;
    const missingB = exists.ListB && !added.ListB;
    const missingM = exists.Music && !added.Music;

    // If nothing is missing, skip this prompt and show the normal family box
    if (!missingA && !missingB && !missingM) {
      hideStBOptionalPrompt();
      showFamilyTools(`✅ Added items for ${snap.childFirst} ${snap.childLast}. Want to add another child?`);
      return;
    }

    // Message
    if (missingA && (missingB || missingM)) {
      msgEl.textContent = "List A is required. Add the remaining items to cart?";
    } else if (missingA) {
      msgEl.textContent = "List A is required. Add List A to cart?";
    } else {
      msgEl.textContent = "Optional lists are available. Add them to cart?";
    }

    // Buttons (show only what’s missing)
    if (missingA) {
      btnA.style.display = "";
      btnA.textContent = `Add ${titleA} to cart (Required)`;
      btnA.disabled = false;
      btnA.classList.remove("booklist-btn--disabled");
    } else {
      btnA.style.display = "none";
    }

    if (missingB) {
      btnB.style.display = "";
      btnB.textContent = `Add ${titleB} to cart`;
      btnB.disabled = false;
      btnB.classList.remove("booklist-btn--disabled");
    } else {
      btnB.style.display = "none";
    }

    if (missingM) {
      btnM.style.display = "";
      btnM.textContent = `Add ${titleM} to cart`;
      btnM.disabled = false;
      btnM.classList.remove("booklist-btn--disabled");
    } else {
      btnM.style.display = "none";
    }

    // Hide the normal family box while this prompt is showing
    if (familyTools) familyTools.style.display = "none";

    stbOptionalCtx = { grid, snap, exists, added };

    el.style.display = "block";
    el.scrollIntoView({ behavior: "smooth", block: "nearest" });
  }

  // ------------------------------ Ends here this function changes
  // New Button Implementation for St. Bernandine State School End of 5 Jan 11pm Changes

  function clearForNextChild() {
    // keep parent details; clear child details + yeargroup
    const childFirst = document.getElementById("child_first");
    const childLast = document.getElementById("child_last");

    if (childFirst) childFirst.value = "";
    if (childLast) childLast.value = "";
    if (yeargroupSelect) yeargroupSelect.value = "";

    // reset booklist id for next child
    currentBooklistId = null;

    checkForm();
    childFirst && childFirst.focus();
  }

  if (addAnotherBtn) {
    addAnotherBtn.addEventListener("click", () => {
      clearForNextChild();
      showFamilyTools("Fill the next child details above, then click “Show booklists”.");
    });
  }

  function getRecommendedQty(schoolKey, schoolyear, yeargroup, handle) {
    try {
      const schoolObj = qtyDb[schoolKey];
      if (!schoolObj) return 1;
      const yearObj = schoolObj[schoolyear];
      if (!yearObj) return 1;
      const groupObj = yearObj[yeargroup];
      if (!groupObj) return 1;
      const raw = groupObj[handle];
      const num = parseInt(raw, 10);
      return Number.isFinite(num) && num > 0 ? num : 1;
    } catch (e) {
      return 1;
    }
  }

  function getSchoolConfig(schoolKey) {
    return schoolsCfg[schoolKey] || null;
  }

  function ensureStBernardinesOption() {
    if (!schoolSelect) return;
    const val = "stbernardinesschoolregentspark";
    const exists = Array.from(schoolSelect.options || []).some((o) => o.value === val);
    if (exists) return;

    const opt = document.createElement("option");
    opt.value = val;
    opt.textContent = "St. Bernardine's Catholic School - Regent Park";
    schoolSelect.appendChild(opt);
  }

  function rebuildYeargroupOptions() {
    if (!yeargroupSelect) return;

    const schoolVal = schoolSelect ? schoolSelect.value : "";
    const sc = getSchoolConfig(schoolVal);
    const config = (sc && sc.yeargroups) || [
      { value: "prep", label: "Prep Year" },
      { value: "year1", label: "Year 1" },
      { value: "year2", label: "Year 2" },
      { value: "year3", label: "Year 3" },
      { value: "year4", label: "Year 4" },
      { value: "year5", label: "Year 5" },
      { value: "year6", label: "Year 6" }
    ];

    // Clear
    while (yeargroupSelect.firstChild) yeargroupSelect.removeChild(yeargroupSelect.firstChild);

    // Placeholder
    const placeholder = document.createElement("option");
    placeholder.value = "";
    placeholder.textContent = "Select year";
    yeargroupSelect.appendChild(placeholder);

    config.forEach((opt) => {
      const o = document.createElement("option");
      o.value = opt.value;
      o.textContent = opt.label;
      yeargroupSelect.appendChild(o);
    });

    yeargroupSelect.value = "";
    checkForm();
  }

  function getProductsForSchool(schoolKey, yeargroup) {
    const packsBySchool = window.bookPacksBySchool || {};
    const packsBySchoolYear = window.bookPacksBySchoolYear || {};

    // Option B support: if a per-yeargroup collection was exposed, use it.
    if (
      yeargroup &&
      packsBySchoolYear[schoolKey] &&
      Array.isArray(packsBySchoolYear[schoolKey][yeargroup])
    ) {
      return packsBySchoolYear[schoolKey][yeargroup];
    }

    // Default: per-school collection
    if (Array.isArray(packsBySchool[schoolKey])) {
      return packsBySchool[schoolKey];
    }

    return [];
  }

  function buildRequiredTags(schoolKey, yeargroup, schoolyear, usingYearCollection) {
    const sc = getSchoolConfig(schoolKey);
    const required = [];

    if (sc && Array.isArray(sc.extraTags)) required.push(...sc.extraTags);

    // If we're already loading from a per-yeargroup collection (Option B),
    // we don't need to require the schoolTag/yeargroup tags (and it avoids tag-mismatch headaches).
    if (!usingYearCollection && sc && sc.schoolTag) required.push(sc.schoolTag);
    if (!usingYearCollection && yeargroup) required.push(yeargroup);

    // Keep schoolyear tag as a safety check (e.g. 2026)
    if (schoolyear) required.push(schoolyear);

    return required.filter(Boolean).map(normalizeTag);
  }

  function filterByRequiredTags(products, requiredNorm) {
    return (products || []).filter((p) => {
      const normTags = getNormalizedTags(p.tags);
      return requiredNorm.every((t) => normTags.includes(t));
    });
  }

  function splitIntoLists(products) {
    const groups = { ListA: [], ListB: [], Music: [] };
    (products || []).forEach((p) => {
      const tags = getNormalizedTags(p.tags);
      if (tags.includes("music")) groups.Music.push(p);
      else if (tags.includes("listb")) groups.ListB.push(p);
      else groups.ListA.push(p); // default bucket
    });
    return groups;
  }
  // NEW Function for Yugumbir School 
  //7 Jan Morning and Splitter for Yugumbir
  function splitYugumbirLists(products, yeargroup) {
    const groups = { Required: [], Optional: [] };
    const yg = String(yeargroup || "").toLowerCase();

    // Prep exception: everything is mandatory
    const forceAllRequired = yg === "prep";

    (products || []).forEach((p) => {
      const tags = getNormalizedTags(p.tags);
      const isOptional = !forceAllRequired && tags.includes("listb");

      if (isOptional) groups.Optional.push(p);
      else groups.Required.push(p);
    });

    return groups;
  }

 /* renderInfoBlock Function v3 Broken Fix. */
 function renderInfoBlock(info, listKey) {
  if (!info || typeof info !== "object") return "";

  // Make CSS class consistent + safe
  const cls = listKey
    ? ` booklist-info--${String(listKey).toLowerCase()}`
    : "";

  // If info is already in the NEW shape, keep it
  const looksNew =
    (info.required && Array.isArray(info.required.items)) ||
    (info.avoid && Array.isArray(info.avoid.items)) ||
    (info.note && Array.isArray(info.note.items));

  const normalized = looksNew
    ? info
    : {
        required: Array.isArray(info.additionalItemsRequired) && info.additionalItemsRequired.length
          ? { label: "Additional items required", items: info.additionalItemsRequired }
          : null,

        avoid: Array.isArray(info.pleaseDoNotBring) && info.pleaseDoNotBring.length
          ? { label: "Please do not bring", items: info.pleaseDoNotBring }
          : null,

        note: (() => {
          const items = [];

          // old format: note is a string (ListB uses this) :contentReference[oaicite:4]{index=4}
          if (typeof info.note === "string" && info.note.trim()) items.push(info.note.trim());

          // old format: notes is an array (ListA uses this) :contentReference[oaicite:5]{index=5}
          if (Array.isArray(info.notes) && info.notes.length) items.push(...info.notes);

          return items.length ? { label: "Please", items } : null;
        })(),
      };

  function sectionHtml(section) {
    if (!section || !Array.isArray(section.items) || section.items.length === 0) return "";
    const label = section.label ? escapeHtml(section.label) : "";
    const items = section.items.map(it => `<li>${escapeHtml(it)}</li>`).join("");
    return `
      <div class="booklist-info__section">
        ${label ? `<div class="booklist-info__label">${label}:</div>` : ""}
        <ul class="booklist-info__list">${items}</ul>
      </div>
    `;
  }

  const required = sectionHtml(normalized.required);
  const avoid    = sectionHtml(normalized.avoid);
  const note     = sectionHtml(normalized.note);

  if (!required && !avoid && !note) return "";

  return `
    <div class="booklist-info${cls}">
      ${required}${avoid}${note}
    </div>
  `;
}



  function escapeHtml(str) {
    return String(str || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function makeRowHtml(p, recommendedQty) {
    return `
      <div class="booklist-row" data-variant-id="${p.variant_id}">
        <div class="booklist-row__title">
          <div class="booklist-row__title-heading">${escapeHtml(p.title)}</div>
          <a class="booklist-row__title-link" href="${p.url}">Click to view full book pack details</a>
        </div>
        <div class="booklist-row__qty">
          <label>Quantity</label>
          <input type="number" min="0" value="${recommendedQty}">
        </div>
      </div>
    `;
  }

  function getFormSnapshot() {
    const parentFirst = (document.getElementById("parent_first")?.value || "").trim();
    const parentLast = (document.getElementById("parent_last")?.value || "").trim();
    const childFirst = (document.getElementById("child_first")?.value || "").trim();
    const childLast = (document.getElementById("child_last")?.value || "").trim();

    const schoolKey = (schoolSelect?.value || "").trim();
    const yeargroup = (yeargroupSelect?.value || "").trim();
    const schoolyear = (schoolYearSelect?.value || "").trim();

    const schoolLabel = schoolSelect?.options?.[schoolSelect.selectedIndex]?.text || "";
    const yearGroupLabel = yeargroupSelect?.options?.[yeargroupSelect.selectedIndex]?.text || "";
    const schoolYearLabel = schoolYearSelect?.options?.[schoolYearSelect.selectedIndex]?.text || "";

    return {
      parentFirst, parentLast, childFirst, childLast,
      schoolKey, yeargroup, schoolyear,
      schoolLabel, yearGroupLabel, schoolYearLabel
    };
  }

  function ensureCurrentBooklistId() {
    if (!currentBooklistId) currentBooklistId = makeBooklistId();
    return currentBooklistId;
  }
  /* Old was :- async function addRowsToCart(rows, listKeyOrNull) */
  async function addRowsToCart(rows, listKeyOrNull, opts = {}) {
    const snap = getFormSnapshot();
    const items = [];

    rows.forEach((row) => {
      const variantId = row.dataset.variantId;
      const input = row.querySelector('input[type="number"]');
      if (!variantId || !input) return;

      const qty = parseInt(input.value, 10);
      if (qty && qty > 0) items.push({ id: Number(variantId), quantity: qty });
    });

    if (!items.length) {
      alert("Please enter a quantity greater than 0 for at least one item.");
      return;
    }

    const booklistId = ensureCurrentBooklistId();

    const properties = {
      _bl_id: booklistId,
      _bl_child: `${snap.childFirst} ${snap.childLast}`.trim(),
      _bl_parent: `${snap.parentFirst} ${snap.parentLast}`.trim(),
      _bl_school: snap.schoolKey,
      _bl_school_label: snap.schoolLabel,
      _bl_yeargroup: snap.yeargroup,
      _bl_yeargroup_label: snap.yearGroupLabel,
      _bl_schoolyear: snap.schoolyear,
      _bl_schoolyear_label: snap.schoolYearLabel,
      _bl_type: "booklist"
    };

    if (listKeyOrNull) properties._bl_list = listKeyOrNull;

    const itemsWithProps = items.map((it) => ({
      id: it.id,
      quantity: it.quantity,
      properties
    }));

    await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: itemsWithProps })
    });

    await upsertBooklistMeta({
      id: booklistId,
      parentFirst: snap.parentFirst,
      parentLast: snap.parentLast,
      childFirst: snap.childFirst,
      childLast: snap.childLast,
      school: snap.schoolKey,
      yeargroup: snap.yeargroup,
      schoolyear: snap.schoolyear,
      schoolLabel: snap.schoolLabel,
      yearGroupLabel: snap.yearGroupLabel,
      schoolYearLabel: snap.schoolYearLabel,
      createdAt: new Date().toISOString()
    });
    if (!opts.suppressFamilyTools) {
      showFamilyTools(`✅ Added items for ${snap.childFirst} ${snap.childLast}. Want to add another child?`); 
    }
  }

  // ---------------- Form validation ----------------
  function checkForm() {
    const inputs = form.querySelectorAll("input[required], select[required]");
    let allFilled = true;
    inputs.forEach((input) => {
      if (!String(input.value || "").trim()) allFilled = false;
    });

    if (btn) {
      btn.disabled = !allFilled;
      btn.classList.toggle("booklist-btn--disabled", !allFilled);
    }
  }

  // ---------------- Init ----------------
  ensureStBernardinesOption();
  rebuildYeargroupOptions();

  if (schoolSelect) schoolSelect.addEventListener("change", rebuildYeargroupOptions);

  form.querySelectorAll("input, select").forEach((el) => {
    el.addEventListener("input", checkForm);
    el.addEventListener("change", checkForm);
  });
  checkForm();

  // ---------------- Submit (show booklist) ----------------
  form.addEventListener("submit", (e) => {
    e.preventDefault();
    // Extra Dialogue For St Bernardine’s School
    removeStBNotice();
    // Extra Dialogue For Brighton State School
    removeBrightonNotice();
    removeYugNotice();
    hideYugOptionalPrompt();
    hideStBOptionalPrompt();

    const snap = getFormSnapshot();
    const allPacks = getProductsForSchool(snap.schoolKey, snap.yeargroup);

    if (!allPacks.length) {
      grid.innerHTML = '<p class="booklist-empty" style="padding:1.25rem;text-align:center;">No book-pack products are configured yet.</p>';
      resultsWrapper.style.display = "block";
      return;
    }

    const usingYearCollection = !!(window.bookPacksBySchoolYear && window.bookPacksBySchoolYear[snap.schoolKey] && window.bookPacksBySchoolYear[snap.schoolKey][snap.yeargroup]);
    const requiredNorm = buildRequiredTags(snap.schoolKey, snap.yeargroup, snap.schoolyear, usingYearCollection);
    const matching = filterByRequiredTags(allPacks, requiredNorm);

    // Default UI state
    if (bottomActions) bottomActions.style.display = "";
    if (addAllButton) addAllButton.style.display = "";

    grid.innerHTML = "";
    if (!matching.length) {
      grid.innerHTML = '<p class="booklist-empty" style="padding:1.25rem;text-align:center;">No booklist found for this selection.</p>';
      resultsWrapper.style.display = "block";
      resultsWrapper.scrollIntoView({ behavior: "smooth" });
      // Removal of Extra Dialogue For St Bernardine’s School /* New change 5:19pm 5 Jan */ 
      removeStBNotice();
      // Removal of Extra Dialogue For Brighton State School
      removeBrightonNotice();
      // Removal of Extra Dialogue For Yugumbir State School
      removeYugNotice();
      /* New change end 5:19pm 5 Jan */ 
      return;
    }
       // Insertion of Extra Dialogue For Brighton State School
    const isBrighton = snap.schoolKey === "brightonstateschool";
    if (isBrighton) { 
      upsertBrightonNotice(); 
    }
    const isYug = snap.schoolKey === "yugumbirstateschool";

    // Show Yug notice ONLY if ListB exists in THIS selection
    const yugHasListB =
      isYug &&
      Array.isArray(matching) &&
      matching.some(p => getNormalizedTags(p.tags).includes("listb"));

    if (yugHasListB) upsertYugNotice();
    else removeYugNotice();

    const isStB = snap.schoolKey === "stbernardinesschoolregentspark";

    // -------- Yugumbir School sections --------
    // New Code for Yugumbir School 7 jan morning
    //const isYug = snap.schoolKey === "yugumbirstateschool";

    if (isYug) {
      // Hide bottom "Add entire booklist" button area
      if (bottomActions) bottomActions.style.display = "none";
      if (addAllButton) addAllButton.style.display = "none";

      const groups = splitYugumbirLists(matching, snap.yeargroup);

      const yugExists = {
        Required: true,
        Optional: !!(groups.Optional && groups.Optional.length)
      };

      const yugAdded = { Required: false, Optional: false };

      const requiredRowsHtml = groups.Required
        .map((p) => makeRowHtml(p, getRecommendedQty(snap.schoolKey, snap.schoolyear, snap.yeargroup, p.handle)))
        .join("");

      const optionalRowsHtml = groups.Optional
        .map((p) => makeRowHtml(p, getRecommendedQty(snap.schoolKey, snap.schoolyear, snap.yeargroup, p.handle)))
        .join("");

      
      // New Function for Fixing 12am 8 Jan 

      function renderYugSection(key, titleHtml, rowsHtml, buttonText) {
        return `
          <div class="booklist-section" data-yug-section="${key}">
            <div style="margin-bottom:.75rem;">
              ${titleHtml}
            </div>

            <div class="booklist-listwrap">
              ${rowsHtml}
            </div>

            <div class="booklist-actions yug-actions">
              <button type="button" class="booklist-btn" data-yug-add="${key}">
                ${buttonText}
              </button>
            </div>
          </div>
        `;
      }


      const requiredSection = renderYugSection(
        "Required",
        `<div class="yug-title-line">Required items (Mandatory)</div>`,
        requiredRowsHtml,
        "Add Required items list to cart"
      );

      const optionalSection = yugExists.Optional
        ? renderYugSection(
            "Optional",
            `
              <div class="yug-title-line">THESE ITEMS MAY CARRY OVER FROM THE PREVIOUS YEAR.</div>
              <div class="yug-title-line">PURCHASE ONLY IF REPLACEMENT NEEDED. (Optional Purchase)</div>
            `,
            optionalRowsHtml,
            "Add Optional items list to cart"
          )
        : "";

      grid.innerHTML = `
        <div class="booklist-card">
          ${requiredSection}
          ${optionalSection}
        </div>
      `;

      // Yugumbir click handling (delegated)
      grid.onclick = async (ev) => {
        const btnEl = ev.target.closest("[data-yug-add]");
        if (!btnEl) return;

        ev.preventDefault(); // safety

        const key = btnEl.getAttribute("data-yug-add"); // "Required" | "Optional"
        const snapNow = getFormSnapshot();

        // If already added, just show what’s missing
        if (yugAdded[key]) {
          showYugOptionalPrompt({ grid, snap: snapNow, exists: yugExists, added: yugAdded });
          return;
        }

        const section = grid.querySelector(`[data-yug-section="${key}"]`);
        if (!section) return;

        const rows = Array.from(section.querySelectorAll(".booklist-row"));
        if (!rows.length) return;

        const originalText = btnEl.textContent;

        btnEl.disabled = true;
        btnEl.classList.add("booklist-btn--disabled");
        btnEl.textContent = "Adding items… please wait";

        try {
          // IMPORTANT: suppress the normal family box until AFTER the Yug prompt
          await addRowsToCart(rows, key, { suppressFamilyTools: true });
          yugAdded[key] = true;

          // Show missing items prompt
          showYugOptionalPrompt({ grid, snap: snapNow, exists: yugExists, added: yugAdded });
        } catch (err) {
          console.error(err);
          alert("Something went wrong while adding items. Please try again.");
        } finally {
          btnEl.disabled = false;
          btnEl.classList.remove("booklist-btn--disabled");
          btnEl.textContent = originalText;
        }
      };


      resultsWrapper.style.display = "block";
      resultsWrapper.scrollIntoView({ behavior: "smooth" });
      return;
    }

    // Ends here for Yugumbir School 

    // -------- St Bernardine’s: render ListA/ListB/Music sections --------
    if (isStB) {
      if (bottomActions) bottomActions.style.display = "none"; // hide the big bottom button

      const groups = splitIntoLists(matching);
      // Add a “per selection” state object (reset every time StB booklists are rendered)
      const stbExists = {
        ListA: true,
        ListB: !!(groups.ListB && groups.ListB.length),
        Music: !!(groups.Music && groups.Music.length),
      };
      // reset each time they click "Show Booklists"
      const stbAdded = { ListA: false, ListB: false, Music: false };

      // Insertion of Extra Dialogue for St Bernardine’s School /* New change 5:19pm 5 Jan */ 
      upsertStBNotice(groups);
      /* New change end 5:19pm 5 Jan */ 

      const sc = getSchoolConfig(snap.schoolKey);
      const infoRoot = (sc && sc.yeargroupInfo && sc.yeargroupInfo[snap.yeargroup]) ? sc.yeargroupInfo[snap.yeargroup] : {};

      const order = ["ListA", "ListB", "Music"];
      const html = order
        .filter((k) => groups[k] && groups[k].length)
        .map((k) => {
          const meta = listMeta[k] || { title: k, subtitle: "" };
          const info = infoRoot ? infoRoot[k] : null;

          const rowsHtml = groups[k]
            .map((p) => makeRowHtml(p, getRecommendedQty(snap.schoolKey, snap.schoolyear, snap.yeargroup, p.handle)))
            .join("");

          /* Old way :-
              <div style="margin-bottom:.75rem;">
                <div style="font-weight:700; font-size:1.05rem;">${escapeHtml(meta.title)}</div>
                ${meta.subtitle ? `<div class="bookpack-muted" style="margin-top:.2rem;">${escapeHtml(meta.subtitle)}</div>` : ""}
              </div>

            New Way :- 
              <div style="margin-bottom:.75rem;">
                <div style="font-weight:700; font-size:1.05rem;">
                  ${escapeHtml(meta.title)}
                    ${meta.subtitle ? ` <span class="booklist-list-subtitle">(<strong>${escapeHtml(meta.subtitle)}</strong>)</span>` : ""}
                </div>
              </div>
          */
          return `
            <div class="booklist-listblock" data-list-section="${k}" style="padding:1.25rem; border-bottom:1px solid #f2f2f2;">
              <div class="booklist-listhead">
                <div class="booklist-listhead__line">
                  ${escapeHtml(meta.title)}
                  ${meta.subtitle ? ` <span class="booklist-listhead__subtitle">(${escapeHtml(meta.subtitle)})</span>` : ""}
                </div>
              </div>


              ${renderInfoBlock(info, k)}

              <div class="booklist-row-list" style="border:1px solid #eee; border-radius:14px; overflow:hidden;">
                ${rowsHtml}
              </div>

              <div class="booklist-actions" style="margin-top:1rem;">
                <button type="button" class="booklist-btn" data-add-list="${k}">
                  Add ${escapeHtml(meta.title)} to cart
                </button>
              </div>
            </div>
          `;
        })
        .join("");

      grid.innerHTML = html;

      // Event delegation for list add buttons

      /* New Version v2 for grid.onClick */
      grid.onclick = async (ev) => {
        const btnEl = ev.target.closest("[data-add-list]");
        if (!btnEl) return;

        const listKey = btnEl.getAttribute("data-add-list");
        const section = btnEl.closest("[data-list-section]");
        if (!section) return;

        const snapNow = getFormSnapshot();

        // If they already added this list in this session, don't add again — just show what's missing
        if (stbAdded[listKey]) {
          showStBOptionalPrompt({ grid, snap: snapNow, exists: stbExists, added: stbAdded });
          return;
        }

        const rows = Array.from(section.querySelectorAll(".booklist-row"));
        if (!rows.length) return;

        const originalText = btnEl.textContent;

        btnEl.disabled = true;
        btnEl.classList.add("booklist-btn--disabled");
        btnEl.textContent = "Adding items… please wait";

        try {
          await addRowsToCart(rows, listKey, { suppressFamilyTools: true });
          stbAdded[listKey] = true;

          // After any add (A/B/Music), show missing options (ListA required will show if missing)
          showStBOptionalPrompt({ grid, snap: snapNow, exists: stbExists, added: stbAdded });
        } catch (err) {
          console.error(err);
          alert("Something went wrong while adding items. Please try again.");
        } finally {
          btnEl.disabled = false;
          btnEl.classList.remove("booklist-btn--disabled");
          btnEl.textContent = originalText;
        }
      };


      resultsWrapper.style.display = "block";
      resultsWrapper.scrollIntoView({ behavior: "smooth" });
      return;
    }
    // Extra Dialogue For St Bernardine’s School /* New change 5:19pm 5 Jan */ 
    removeStBNotice();
    /* New change end 5:19pm 5 Jan */ 
    // -------- Other schools: keep your original single list + “Add entire booklist” --------
    matching.forEach((p) => {
      const recommendedQty = getRecommendedQty(snap.schoolKey, snap.schoolyear, snap.yeargroup, p.handle);
      grid.insertAdjacentHTML("beforeend", makeRowHtml(p, recommendedQty));
    });

    resultsWrapper.style.display = "block";
    resultsWrapper.scrollIntoView({ behavior: "smooth" });

    if (addAllButton) {
      addAllButton.onclick = async () => {
        const rows = Array.from(document.querySelectorAll(".booklist-row"));

        const originalText = addAllButton.textContent;
        addAllButton.disabled = true;
        addAllButton.classList.add("booklist-btn--disabled");
        addAllButton.textContent = "Adding items… please wait";

        try {
          // For non-StB, one-click add is fine (still one booklist id)
          await addRowsToCart(rows, null);

          addAllButton.disabled = false;
          addAllButton.classList.remove("booklist-btn--disabled");
          addAllButton.textContent = originalText;
        } catch (err) {
          console.error(err);
          alert("Something went wrong while adding items. Please try again.");
          addAllButton.disabled = false;
          addAllButton.classList.remove("booklist-btn--disabled");
          addAllButton.textContent = originalText;
        }
      };
    }
  });
})();